import { config as calendar } from './calendar/config';
import { config as flights } from './flights/config';
import { config as geo } from './geo/config';
import { config as lifeEvents } from './lifeEvents/config';
import { config as location } from './location/config';
import { config as portfolio } from './portfolio/config';
import { config as pulse } from './pulse/config';
import { config as vitals } from './vitals/config';

export const SOURCES = {
  flights,
  vitals,
  location,
  geo,
  lifeEvents,
  calendar,
  portfolio,
  pulse,
};

export type SourceId = keyof typeof SOURCES;
export type { SourceDefinition as SourceDef, SourceKind } from './types';
